import React, { useState, useMemo } from 'react';
import ReactDatePicker from "react-datepicker";
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Layout from 'layout';
import AreaFilter from 'components/AreaFilter';
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import { mainUrl } from 'API/client/api';
import { downloadBlobAsFile } from 'utils/utils';
import { onLoading } from "store/slices/loaderSlice";
import useDateRange from 'hooks/useDateRange';

const GuestReport = () => {

  const dispatch = useDispatch();
  const { fromdate, todate, setFromDate, setToDate } = useDateRange();
  const { userDetail } = useSelector(authenticationSeletor);
  const { access_token } = useSelector((state) => state.authentication)

  const [selectedProperty, setSelectedProperty] = useState([]);

  const rroomUser = userDetail?.logintype == "rroomUser"
  const selectedPropertyIdList = useMemo(() => {
    return selectedProperty?.map((item) => item?.id).toString()
  }, [selectedProperty])

  const onSubmit = async (e) => {
    e.preventDefault();
    dispatch(onLoading(true))
    try {
      const finalPropertyId = userDetail?.propertyId || selectedPropertyIdList;
      const newFromDate = moment(fromdate).format("YYYY-MM-DD")
      const newToDate = moment(todate).format("YYYY-MM-DD")  
      const newPropertyIds = finalPropertyId ? `&propertyId=${finalPropertyId}` : '';
      const queryParams =
        newFromDate && newToDate ? `?fromDate=${encodeURIComponent(newFromDate)}&toDate=${encodeURIComponent(newToDate)}` : "";
      const response = await fetch(`${mainUrl}api/booking/export-walkin-users/${userDetail?.propertyId}${queryParams}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${access_token}`
        }
      });
      if (response.ok) {
        const blob = await response.blob();
        downloadBlobAsFile(blob, `Guest-Report-${moment().format("YYYY-MM-DD")}.xlsx`)
      }
      else {
        console.error("Failed to download file");
      }
    }
    catch { console.error("Failed to download file"); }
    finally {
      dispatch(onLoading(false))
    }
  }

  return (
    <Layout>
      <div className='report-section'>
        <div className='row justify-content-center'>
          <div className={`col-lg-${rroomUser ? 5 : 3}`}>
            <div className='pt-3 pb-3'>
              {rroomUser && <AreaFilter aSize={4} bSize={8} onPropertyChange={(value) => setSelectedProperty(value)} />}
              <div className='row'>
                <div className={`col-lg-${rroomUser ? 6 : 12}`}>
                  <div className='form-group'>
                    <label className="text-black m-0 fs-7">From Date: </label>
                    <ReactDatePicker
                      className="form-control"
                      customclassName="form-control"
                      onChange={(date) => {
                        setFromDate(date);
                      }}
                      selected={new Date(fromdate)}
                      dateFormat="yyyy/MM/dd"
                    />
                  </div>
                </div>
                <div className={`col-lg-${rroomUser ? 6 : 12}`}>
                  <div className='form-group'>
                    <label className="text-black m-0 fs-7">To Date: </label>
                    <ReactDatePicker
                      className="form-control"
                      minDate={fromdate}
                      customclassName="form-control"
                      onChange={(date) => {
                        setToDate(date);
                      }}
                      selected={new Date(todate)}
                      dateFormat="yyyy/MM/dd"
                    />
                  </div>
                </div>
                <div className='col-lg-12 text-right'>
                  <button onClick={(e) => onSubmit(e)} className="btn btn-success rounded-5">Export Excel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default GuestReport;